import { Box, Button, Typography, makeStyles } from '@material-ui/core'
import Icon from '@mdi/react'
import {
  mdiAlertCircleOutline,
  mdiArrowRight,
  mdiClockAlertOutline,
} from '@mdi/js'
import React from 'react'

import colors from '../../../assets/colors'

const TONES = {
  error: {
    color: colors.error,
    bg: colors.bgError,
    icon: mdiAlertCircleOutline,
  },
  info: {
    color: colors.info,
    bg: colors.bgInfo,
    icon: mdiClockAlertOutline,
  },
}

const useStyles = makeStyles({
  banner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12px',
    flexWrap: 'wrap',
    padding: '12px 16px',
    borderRadius: '10px',
    borderLeft: '4px solid',
  },
  message: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  text: {
    fontSize: '14px',
    color: colors.textCustom,
    lineHeight: 1.4,
  },
  action: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    fontSize: '13px',
    fontWeight: 700,
    borderRadius: '16px',
    padding: '6px 16px',
    whiteSpace: 'nowrap',
    textTransform: 'none',
    backgroundColor: '#FFF',
    transition: 'all .2s ease-in-out',
    '&:hover': {
      backgroundColor: '#FFF',
      opacity: 0.75,
    },
  },
})

const SubscriptionAlertBanner = ({ tone = 'info', message, actionLabel }) => {
  const classes = useStyles()
  const meta = TONES[tone] || TONES.info

  if (!message) return null

  return (
    <Box
      className={classes.banner}
      style={{ borderLeftColor: meta.color, backgroundColor: meta.bg }}
    >
      <Box className={classes.message}>
        <Icon path={meta.icon} size={0.95} color={meta.color} />
        <Typography className={classes.text}>{message}</Typography>
      </Box>
    </Box>
  )
}

export default SubscriptionAlertBanner
